<template>
  <div class="tooltip" @mouseleave="onMouseleave">
    <div ref="content" :class="wrapClasses" :style="contentStyle">
      <div class="tooltip__wrap__content">
        <slot name="default"></slot>
        <span class="tooltip__wrap__content__close" @click="closeTooltip" v-if="!hover"></span>
      </div>
    </div>
    <div ref="activator" class="tooltip__activator" @mouseover="onMouseover">
      <slot name="activator"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppTooltip',
  status: 'prototype',
  release: '1.0.0',
  props: {
    value: {
      required: false
    },
    hover: {
      type: Boolean,
      default: false
    },
    bottom: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: this.value || false,
      canSetToTop: false,
      contentPosition: 0
    }
  },
  computed: {
    wrapClasses () {
      return {
        'tooltip__wrap': 'tooltip__wrap',
        'tooltip__wrap--open': !!this.isOpen,
        'tooltip__wrap--bottom': !this.canSetToTop || this.bottom
      }
    },
    contentStyle () {
      return {
        'transform': `translateY(${this.contentPosition}px)`
      }
    }
  },
  watch: {
    value (val) {
      this.isOpen = val
    }
  },
  mounted () {
    this.checkPostion()
    window.addEventListener('resize', () => {
      this.checkPostion()
    })
  },
  methods: {
    onMouseleave () {
      if (this.hover) {
        this.closeTooltip()
      }
    },
    onMouseover () {
      if (this.hover) {
        this.openTooltip()
      }
    },
    closeTooltip () {
      this.changeState(false)
      this.$emit('close')
    },
    openTooltip () {
      this.changeState(true)
      setTimeout(() => this.checkPostion(), 10)
      this.$emit('open')
    },
    changeState (state) {
      this.isOpen = state
      this.$emit('input', state)
    },
    checkPostion () {
      if (!!this.$refs.activator && !!this.$refs.content) {
        const doc = document.documentElement
        const scrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
        const contentHeight = this.$refs.content.offsetHeight
        const activatorHeight = this.$refs.activator.offsetHeight
        const canSetToTop = this.$refs.activator.getClientRects()[0].y >= contentHeight
        this.canSetToTop = canSetToTop
        this.contentPosition = canSetToTop && !this.bottom ? contentHeight * -1 : activatorHeight
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
.tooltip {
  @include reset();
  position: relative;
  &__wrap {
    position: absolute;
    display: none;
    padding-bottom: 7px;
    max-width: 90%;
    transform: translateY(-100%);
    z-index: 999;
    &--open {
      display: block;
    }
    &--bottom {
      padding-top: 7px;
      padding-bottom: 0;
      .tooltip__wrap__content {
        &::before {
          top: -14px;
          bottom: auto;
          border: 7px solid transparent;
          border-bottom:7px solid $color-purple-darker;
        }
      }
    }
    &__content {
      position: relative;
      padding: 18px 35px 18px 20px;
      font-family: $font-text;
      font-size: $size-xs;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.29;
      letter-spacing: normal;
      color: $color-white;
      border-radius: 15px;
      background-color: $color-purple-darker;
      &::before {
        position: absolute;
        display: inline-block;
        content: "";
        width: 0;
        height: 0;
        left: 23px;
        top: auto;
        bottom: -14px;
        border: 7px solid transparent;
        border-top: 7px solid $color-purple-darker;
      }
      &__close {
        position: absolute;
        display: inline-block;
        width: 30px;
        height: 30px;
        top: 5px;
        right: 5px;
        cursor: pointer;
        &::after,
        &::before {
          position: absolute;
          display: inline-block;
          content: "";
          width: 50%;
          height: 2px;
          left: 50%;
          background: $color-white;
          transform-origin: 0% 0%;
        }
        &::before {
          transform: translate(-7px, 20px) rotateZ(-45deg);
        }
        &::after {
          transform: translate(-5px, 9px) rotateZ(45deg);
        }
      }
    }
  }
}
</style>
